const comments = [
  {
    name: '影视爱好者小李',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20man%20with%20friendly%20smile%2C%20clean%20studio%20portrait%2C%20neutral%20gray%20background%2C%20soft%20natural%20lighting%2C%20casual%20style&width=120&height=120&seq=avatar-c1&orientation=squarish',
    date: '2026-07-28',
    rating: 5,
    content: '私密视频是我用过最流畅的视频平台！红桃视频和西瓜视频的资源特别全，高清画质播放从不卡顿，茄子视频的欧美大片也很给力。推荐给身边所有喜欢看电影的朋友了！',
  },
  {
    name: '追剧达人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20man%20with%20confident%20expression%2C%20clean%20studio%20portrait%2C%20neutral%20gray%20background%2C%20soft%20natural%20lighting%2C%20modern%20style&width=120&height=120&seq=avatar-c2&orientation=squarish',
    date: '2026-07-26',
    rating: 5,
    content: '之前用其他平台看小蓝视频总是缓冲，换了私密视频之后真的不缓冲了！久久视频和芒果视频的资源更新速度也很快，新番上线几乎同步，追番体验满分。',
  },
  {
    name: '宝妈追剧日记',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Asian%20woman%20with%20warm%20smile%2C%20clean%20studio%20portrait%2C%20neutral%20gray%20background%2C%20soft%20natural%20lighting%2C%20elegant%20style&width=120&height=120&seq=avatar-c3&orientation=squarish',
    date: '2026-07-24',
    rating: 4,
    content: '带娃间隙就想看点轻松的，私密视频上面的综艺节目太全了！芒果视频独家综艺和西瓜视频免费的经典剧集，高清画质看着就是舒服，界面简洁好操作，对宝妈太友好了。',
  },
  {
    name: '电影发烧友老王',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20mature%20Asian%20man%20with%20thoughtful%20expression%2C%20clean%20studio%20portrait%2C%20neutral%20gray%20background%2C%20soft%20natural%20lighting%2C%20classic%20style&width=120&height=120&seq=avatar-c4&orientation=squarish',
    date: '2026-07-22',
    rating: 5,
    content: '作为老影迷，私密视频的纪录片资源让我惊喜！BBC和NHK的高清纪录片全集都有，久久视频的经典老片修复画质也很赞。茄子视频的独立电影专区更是挖到不少宝藏。',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">
            听听用户怎么说
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            来自真实用户的使用体验，品质口碑值得信赖
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-sm font-semibold text-foreground-900">{comment.name}</h3>
                    <span className="text-xs text-foreground-400 whitespace-nowrap ml-2">{comment.date}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-xs ${
                          i < comment.rating ? 'text-accent-500' : 'text-foreground-200'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}